import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from "styled-dropdown-component";
import ProfilePic from "../../../Header/profile-pic-header.png";
import { Form } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import { InputText } from "../../../../Shared/FormFields";
import DatePicker from "react-datepicker";
import Calendar from "../../calendar.png";
import ClickOutside from "react-simple-click-outside";
import { ChevronDown } from "styled-icons/boxicons-regular";
import { format } from "date-fns";
import {
  updateManagerScheduleHours,
  updateManagerWeeklySchedule,
} from "../../../../../Actions";
import { withTranslation, Trans } from "react-i18next";
import { dateFormat } from "../../../../../Api/Utils/ReuseableFunctions";
import WeekPlanner from "../../WeekPlanner";
import "react-toggle/style.css";
import Toggle from "react-toggle";
class ShiftAllocation extends Component {
  constructor(props) {
    super(props);
    let formData = props.employeeDetails ? props.employeeDetails : null;
    this.isEndDateRepeat = true;
    this.selectedDate = props.otherData
      ? dateFormat(props.otherData.timesheetDate)
      : new Date();
    this.state = {
      weekPlannerSelected: undefined,
      hiddenWeekName: true,
      hiddenWeek: true,
      hiddenRepeat: true,
      hidden: true,
      isGoing: true,
      repeats: "weekly",
      formData: {
        shiftAllocation: props.otherData
          ? props.otherData.shiftAllocation
          : null,
        comments:
          props.otherData && props.otherData.comments
            ? props.otherData.comments
            : "",
        role: formData.role,
        ssoId: formData.ssoId,
        shiftId: props.otherData ? props.otherData.shiftId : null,
        repeatEndDate: props.otherData.timesheetDate,
        applicableInWeekends: "N",
        repeatCycleCd: "W",
        repeatStartDate: props.otherData.timesheetDate,
        maintUser: "",
        repeatOnWeekDay: props.otherData.timesheetDate,
        firstName: formData ? formData.firstName : "",
        planId: null,
        weekNr: null,
      },
      shiftList: undefined,
      shiftAllocation: props.otherData
        ? props.otherData.shiftAllocation
          ? props.otherData.shiftAllocation
          : "default"
        : "default",
      employeeDetails: undefined,
      weekScheduler: true,
    };
  }
  handleOpenCloseDropdown(name) {
    if (name !== "repeatCycleCd") {
      this.setState({
        hidden: !this.state.hidden,
      });
    } else {
      this.setState({
        hiddenRepeat: !this.state.hiddenRepeat,
      });
    }
    if (name === "hiddenWeek") {
      this.setState((state) => {
        return { hiddenWeek: !state.hiddenWeek };
      });
    }
  }
  componentDidMount() {
    if (this.props.employeeDetails !== void 0) {
      this.setState({
        shiftList: this.props.shiftData,
        employeeDetails: this.props.employeeDetails,
      });
    }
  }
  _close = (target) => {
    this.setState({
      [target]: true,
    });
  };
  handleFormChange = (data, name) => {
    let formData = this.state.formData;
    if (name === "repeatEndDate") {
      this.selectedDate = data;
    } else {
      formData[name] = data;
    }
    formData.repeatEndDate = format(this.selectedDate, "dd/MM/yyyy");
    this.setState({ formData });
  };
  handleSubmit(e) {
    e.preventDefault();
  }
  selectShiftData = (shiftData) => {
    let formData = this.state.formData;
    formData.shiftId = shiftData.shiftId;
    formData.shiftAllocation = shiftData.shiftPlan;
    this.setState({
      shiftAllocation:
        shiftData.shiftPlan +
        "  " +
        shiftData.shiftStartTime +
        "-" +
        shiftData.shiftEndTime,
      hidden: !this.state.hidden,
      formData,
    });
  };
  Save = () => {
    let formData = this.state.formData;
    formData.maintUser = this.props.ssoId;
    formData.branchNr = this.props.branchId;
    formData.repeatEndDate = this.isEndDateRepeat ? formData.repeatEndDate : format(this.selectedDate, "dd/MM/yyyy");
    this.state.weekScheduler
      ? this.props.dispatch(updateManagerScheduleHours(formData))
      : this.props.dispatch(updateManagerWeeklySchedule(formData));
    this.props.onClose();
  };
  repeatChange = (repeat) => {
    let formData = this.state.formData;
    formData.repeatCycleCd = repeat === "weekly" ? "W" : "D";
    this.setState({
      formData: formData,
      repeats: repeat,
      hiddenRepeat: !this.state.hiddenRepeat,
    });
  };
  toggleChange =()=>{
    this.isEndDateRepeat = !this.isEndDateRepeat;
    if(!this.isEndDateRepeat){
      this.selectedDate.setFullYear(this.selectedDate.getFullYear() + 2);
    }
  }
  filterShiftList = (formData) => {
    let shiftData = this.state.shiftList.filter((shiftData) => {
      return Number(shiftData.shiftId) === Number(formData.shiftId);
    });
    return shiftData;
  };
  switchView = () => {
    let data = this.props.weeklyPlanners.weekPlannerList.filter((item) => {
      return item.planId === this.planId;
    });

    this.setState((state) => {
      return {
        weekScheduler: !state.weekScheduler,
        weekPlannerSelected:
          data.length > 0
            ? data
            : [this.props.weeklyPlanners.weekPlannerList[0]],
      };
    });
  };
  weekPlannerScheduler = (data, plannerName) => {
    let formData = this.state.formData;
    let dataSelected;
    if (plannerName === "weekPlannerSelected") {
      dataSelected = [data];
      formData.planId = data.planId;
      formData.weekNr = data.weekPlannerDetailsList[0].weekNr;
    } else {
      formData.weekNr = data;
    }
    this.setState({ [plannerName]: dataSelected, formData });
  };
  render() {
    const { t, onClose } = this.props;
    const {
      hidden,
      hiddenRepeat,
      formData,
      weekScheduler,
      weekPlannerSelected,
    } = this.state;
    return this.state.shiftList !== void 0 ? (
      <Parent>
        <FORM onSubmit={this.handleSubmit}>
          <COL md={3}>
            <ContButton>
              <img src={ProfilePic} alt="profilepic" />
              <NameSpan>
                {formData.firstName} {"  "}{" "}
              </NameSpan>

              {this.props.weeklyPlanners && (
                <NavigateButton onClick={this.switchView}>
                  {!weekScheduler
                    ? t("goToDayScheduler")
                    : t("goToWeekScheduler")}{" "}
                </NavigateButton>
              )}
            </ContButton>
          </COL>
          <COL md={weekScheduler ? 8 : 9}>
            {weekScheduler ? (
              <Wrapper>
                <Cont className="weekScheduler">
                  <RowCont>
                    <Col sm="3">
                      <label>
                        <Trans>shiftAllocation</Trans>
                      </label>
                      <DropDown>
                        <ClickOutside close={this._close} target="hidden">
                          <div onClick={() => this.handleOpenCloseDropdown()}>
                            {this.filterShiftList(formData).length > 0 ? (
                              this.filterShiftList(formData).map(
                                (data) =>
                                  data.shiftPlan +
                                  " " +
                                  data.shiftStartTime +
                                  " " +
                                  "-" +
                                  " " +
                                  data.shiftEndTime
                              )
                            ) : (
                              <Trans>selectShift</Trans>
                            )}{" "}
                            <Chevrondown size="20" />
                          </div>
                          <DropDownMenu hidden={hidden}>
                            {this.state.shiftList.map((shiftData) => (
                              <DropdownItem
                                onClick={() => this.selectShiftData(shiftData)}
                                key={shiftData.shiftId}
                              >
                                {shiftData.shiftPlan} {shiftData.shiftStartTime}{" "}
                                -{shiftData.shiftEndTime}
                              </DropdownItem>
                            ))}
                          </DropDownMenu>
                        </ClickOutside>
                      </DropDown>
                    </Col>
                    <Col sm="3">
                      <label>
                        <Trans>repeats</Trans>
                      </label>
                      <DropDown>
                        <ClickOutside close={this._close} target="hiddenRepeat">
                          <div
                            onClick={() =>
                              this.handleOpenCloseDropdown("repeatCycleCd")
                            }
                          >
                            {this.state.repeats} <Chevrondown size="20" />
                          </div>

                          <DropDownMenu hidden={hiddenRepeat}>
                            {["weekly", "daily"].map((repeat, index) => (
                              <DropdownItem
                                onClick={() => this.repeatChange(repeat)}
                                key={index}
                              >
                                <Trans>{repeat}</Trans>
                              </DropdownItem>
                            ))}
                          </DropDownMenu>
                        </ClickOutside>
                      </DropDown>
                    </Col>
                    <Col sm="3">
                      <Span>
                        <Trans>endRepeat</Trans>
                      </Span>
                      <DatePickerDiv
                        customInput={
                          <div className="DateValue">
                            {" "}
                            {format(this.selectedDate, "d MMM yyyy")}{" "}
                          </div>
                        }
                        dateFormat="d MMM yyyy"
                        selected={this.selectedDate}
                        onChange={(data) =>
                          this.handleFormChange(data, "repeatEndDate")
                        }
                        disabled = {!this.isEndDateRepeat}
                        minDate={new Date()}
                        openToDate={new Date()}
                      />
                      <ImageSpan>
                        <Img src={Calendar} alt="Calendar" />
                      </ImageSpan>
                    </Col>
                    <Col sm="3">
                          <Span>
                            <Trans>Apply End Date</Trans>
                          </Span>
                          <ToggleButtonDiv>
                            <Togglebutton
                              defaultChecked={this.isEndDateRepeat}
                              icons={{ checked: "YES", unchecked: "NO" }}
                              onChange={() => {this.toggleChange()}}
                            />
                          </ToggleButtonDiv>
                        </Col>
                  </RowCont>
                  <RowCont>
                    <Col sm="8">
                      <InputText
                        label={t("comments")}
                        name="comments"
                        value={formData.comments}
                        editMode={true}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </Col>
                    <Col sm="2">
                      <label>
                        <Trans>applyOnWeekEnd</Trans>
                      </label>
                      <CheckBoxDiv>
                        <input
                          type="checkbox"
                          name="applicableInWeekends"
                          onChange={(e) =>
                            this.handleFormChange(
                              e.target.value === "on" ? "Y" : "N",
                              e.target.name
                            )
                          }
                        />
                      </CheckBoxDiv>
                    </Col>
                    <Col sm="2" />
                  </RowCont>
                </Cont>
              </Wrapper>
            ) : (
              <WeekPlanner
                comments={formData.comments}
                handleFormChange={this.handleFormChange}
                weekNr={formData.weekNr}
                weekSelected={(data) =>
                  this.weekPlannerScheduler(data, "weekSelected")
                }
                weekPlannerView={(data) =>
                  this.weekPlannerScheduler(data, "weekPlannerSelected")
                }
                height={"true"}
                data={weekPlannerSelected}
              />
            )}
            <FooterDiv margin={weekScheduler}>
              <Btn onClick={onClose}>
                <Trans>cancel</Trans>
              </Btn>
              <BtnSave onClick={this.Save} type="submit">
                <Trans>submit</Trans>
              </BtnSave>
            </FooterDiv>
          </COL>
        </FORM>
      </Parent>
    ) : (
      <div />
    );
  }
}

const mapStateToProps = ({ auth, userMessage, managerTimesheetData }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    shiftData: managerTimesheetData.payload.shiftList,
    weeklyPlanners: managerTimesheetData.payload.weeklyPlanners,
    branchId: auth.user.defaultProfile.branchId,
  };
};

export default connect(mapStateToProps)(withTranslation()(ShiftAllocation));
const NameSpan = styled.span`
  margin-left :10px
  padding-top :10px
`;
const Parent = styled.div`
  height :auto .weekScheduler {
    margin-bottom: 10vh;
  }
`;
const NavigateButton = styled.button`
  position: absolute;
  bottom: 45px;
  margin-left: 24px;
  background: #ffffff;
  border: 1px solid #adb5bd;
  height: 35px;
  border-radius: 25px;
`;
const ContButton = styled.div`
  padding: 3% 0% 0px 29%;
  display: flex;
`;
const FORM = styled(Form)`
  display: flex;
`;
const DropDown = styled(Dropdown)`
  position : relative
  top:5%
  border-bottom: 1px solid #b2b7be;
  white-space: nowrap;
  //overflow: hidden;
  text-overflow: ellipsis;
  width: 94%;
`;
const Chevrondown = styled(ChevronDown)`
  position: absolute;
  left: 93%;
`;
const DropDownMenu = styled(DropdownMenu)`
  overflow-y: scroll;

  max-height: 100px;
`;
const COL = styled(Col)``;
const Wrapper = styled.div`
  margin: 0 auto;
  font-family: Trebuchet MS;
  padding-left: 10px;
  && label {
    font-size: 12px;
    color: #000;
  }
  && input {
    line-height: 20px;
    padding: 5px 0px;
    background: transparent;
  }
`;
const RowCont = styled(Row)`{
  && {
    margin:0;
    text-align:left;
  }
`;
const Cont = styled(Container)`
  && {
    padding-top: 18px;
  }
`;
const DatePickerDiv = styled(DatePicker)`
  background: #f1f4f9;
  padding-left: 3% !important;
  border: 1px solid #707070;
  font-size: 13px;
  text-align: left;
  width: 120px;
  height: 28px;
  padding: 5px 10px 5px;
`;
const ImageSpan = styled.div`
  position: relative;
  left: 96px;
  bottom: 25px;
`;
const Img = styled.img`
  height: 15px;
`;
const Span = styled.div`
  padding-bottom: 4px;
  padding-left: 1px;
  font-size: 13px;
`;
const CheckBoxDiv = styled.div`
  position: relative;
  float: right;
  top: 4px;
  width: 0%;
`;
const FooterDiv = styled.div`

  bottom: 0px;
  margin-bottom: 50px;
  text-align: center;
  width: 100%;
  padding-right: 31%;
  font-size: 12px;
//   margin-top: ${(props) => (props.margin ? "50px" : "30px")};
`;
const Btn = styled.button`
  background: #ffffff;
  border: 1px solid #adb5bd;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
  margin-top: 10px;
`;
const BtnSave = styled.button`
  background: #c4151c;
  margin-top: 10px;
  color: #ffffff;
  border: 1px solid #adb5bd;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
`;
const ToggleButtonDiv = styled.div`
  padding-top: 7px;
  display: table;
  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle:hover:not(.react-toggle--checked) .react-toggle-track {
    background-color: #e0e0e0;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle--checked .react-toggle-track-check {
    opacity: 1 !important;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 50px;
    border-color: #00a6eb;
  }
`;
const Togglebutton = styled(Toggle)`
  border-radius: 35px;
  font-size: 14px;
  .react-toggle-track {
    width: 81px;
    height: 34px;
    background-color: #e0e0e0;
  }
  .react-toggle-thumb {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 26px;
    height: 26px;
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fafafa;
    box-sizing: border-box;
    transition: all 0.15s ease;
  }
  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 8px;
    right: 25px;
    opacity: 1;
    transition: opacity 0.25s ease;
    color: white;
  }
  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 8px;
    left: 14px;
    color: white;
  }
`;
